import { useMemo } from "react";
import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api";
import type { KuerzelDir } from "@/lib/kuerzel";

/**
 * The org-wide Kürzel directory for the memo highlighter: UPPERCASE Kürzel →
 * { id, name }. The `id` is what lets the highlight take the SAME identity hue as
 * the person's avatar. Rarely changes, so a long staleTime; memoised so the Map
 * identity is stable across renders.
 */
export function useKuerzelDirectory(): KuerzelDir {
  const { data } = useQuery({
    queryKey: ["users", "directory"],
    queryFn: () => api.userDirectory(),
    staleTime: 60 * 60_000,
  });
  return useMemo(() => {
    const map: KuerzelDir = new Map();
    for (const e of data ?? []) {
      map.set(e.username.toUpperCase(), { id: e.id, name: e.display_name });
    }
    return map;
  }, [data]);
}
